import Enum from '/@/modules/core/app/helpers/Enum';

export class FinancialAccountMetaType extends Enum {
  static FINANCIAL_ACCOUNT_RRIF_META = 'FinancialAccountRrifMeta';

  static FINANCIAL_ACCOUNT_TFSA_META = 'FinancialAccountTfsaMeta';
}
